import { render, staticRenderFns } from "./ClassesDay.vue?vue&type=template&id=fa6b2cf8&scoped=true&"
import script from "./ClassesDay.vue?vue&type=script&lang=js&"
export * from "./ClassesDay.vue?vue&type=script&lang=js&"
import style0 from "./ClassesDay.vue?vue&type=style&index=0&id=fa6b2cf8&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fa6b2cf8",
  null
  
)

export default component.exports